import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Program from "../components/Program";
import Topic from "../components/Topic";

import { Grid, GridItem, Box, VStack, Text } from "@chakra-ui/react";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

type ProgramItem = {
  day: string;
  title: string;
};

type ConferenceData = {
  browserTitle: string;
  conferenceName: string;
  program: ProgramItem[];
};

export default function AbstractList() {
  const { year } = useParams();

  const [conference, setConference] = useState<ConferenceData | null>(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConference = async () => {
      if (!year) return;
      const docRef = doc(db, "conference", year);
      try {
        const docRef = doc(db, "conference", "2026");

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setConference(docSnap.data() as ConferenceData);
        }
      } catch (error) {
        console.error("Conference取得エラー:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConference();
  }, [year]);

  useEffect(() => {
    if (conference?.browserTitle) {
      document.title = conference.browserTitle;
    }
  }, [conference]);

  if (loading) {
    return (
      <Box p={8}>
        <Text>読み込み中...</Text>
      </Box>
    );
  }

  return (
    <Grid maxW="900px" mx="auto" px={4} py={8} alignItems="start">
      <GridItem mr={4}>
        <VStack align="stretch" spacing={6}>
          <Box>
            <Topic
              title={conference?.conferenceName ?? "日本消化器画像診断研究会"}
            >
              <VStack align="stretch" spacing={4} mt={2}>
                {conference?.program.map((program) => (
                  <Program
                    key={program.day}
                    title={program.title}
                    today={program.day}
                    year={year!}
                  />
                ))}
              </VStack>
            </Topic>
          </Box>
        </VStack>
      </GridItem>
    </Grid>
  );
}
